import React from 'react';

export default function Card({ post, theme }) {
  const isDark = theme === 'dark';

  const photoUrls = post.photo_urls && post.photo_urls.length > 0
    ? post.photo_urls
    : post.photo_url
      ? [post.photo_url]
      : [];

  const styles = {
    card: {
      background: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
      border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
      borderRadius: '0.75rem',
      padding: '1.25rem',
      width: '100%',
      breakInside: 'avoid',
    },
    photoGrid: {
      display: 'grid',
      gridTemplateColumns: photoUrls.length === 1 ? '1fr' : '1fr 1fr',
      gap: '0.3rem',
      marginBottom: '0.85rem',
      borderRadius: '0.5rem',
      overflow: 'hidden',
    },
    photo: {
      width: '100%',
      display: 'block',
      objectFit: 'cover',
      maxHeight: photoUrls.length === 1 ? '420px' : '280px',
    },
    name: {
      fontWeight: 700,
      fontSize: '1rem',
      marginBottom: '0.4rem',
      color: isDark ? '#fff' : '#000',
    },
    message: {
      fontSize: '0.95rem',
      lineHeight: 1.6,
      color: isDark ? 'rgba(255,255,255,0.75)' : 'rgba(0,0,0,0.7)',
      wordBreak: 'break-word',
    },
  };

  return (
    <div style={styles.card}>
      {photoUrls.length > 0 && (
        <div style={styles.photoGrid}>
          {photoUrls.map((url, i) => (
            <img
              key={i}
              src={url}
              alt={post.name || ''}
              style={styles.photo}
              loading="lazy"
            />
          ))}
        </div>
      )}
      {post.name && <div style={styles.name}>{post.name}</div>}
      {post.message && <div style={styles.message}>{post.message}</div>}
    </div>
  );
}
